/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import { combineReducers } from 'redux';

/**
 * Courses reducer
 * @param state
 * @returns {Array}
 */
function courses(state = global.__PRELOADED_STATE.cardsMatrix.courses) {
    return state;
}

/**
 * Date reducer
 * @param state
 * @returns {object}
 */
function date(state = {
    date: global.__PRELOADED_STATE.cardsMatrix.date,
    heading: global.__PRELOADED_STATE.cardsMatrix.heading,
    shortHeading: global.__PRELOADED_STATE.cardsMatrix.shortHeading
}) {
    return state;
}

export default combineReducers({
    courses,
    date
});




// WEBPACK FOOTER //
// ./src/js/Cards/cards.reducer.js